<template>
    <div >
<nav class="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
        <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
          <a class="navbar-brand brand-logo text-success" href="/home">
            <!-- SwapKredo Admin -->
            <img :src="pic" alt="logo" style="width:150px;border-radius: 50%;"/>
          </a>
          <a class="navbar-brand brand-logo-mini" href="/home"><img :src="pic" alt="logo" /></a>

        </div>
        <div class="navbar-menu-wrapper d-flex align-items-stretch">
          <button class="navbar-toggler navbar-toggler align-self-center" type="button" data-toggle="minimize">
            <span class="mdi mdi-menu"></span>
          </button>
          <div class="search-field d-none d-xl-block">
            <form class="d-flex align-items-center h-100" action="#">
              <div class="input-group">
                <div class="input-group-prepend bg-transparent">
                  <i class="input-group-text border-0 mdi mdi-magnify"></i>
                </div>
                <input type="text" class="form-control bg-transparent border-0" placeholder="Search products">
              </div>
            </form>
          </div>
          <ul class="navbar-nav navbar-nav-right">

            <li class="nav-item nav-profile dropdown">
              <a class="nav-link dropdown-toggle" id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                <div class="nav-profile-img">
                  <img :src="pic" alt="image">
                </div>
                <div class="nav-profile-text">
                  <p class="mb-1 text-black">{{lname}} {{fname}}</p>
                </div>
              </a>
              <div class="dropdown-menu navbar-dropdown dropdown-menu-right p-0 border-0 font-size-sm" aria-labelledby="profileDropdown" data-x-placement="bottom-end">
                <div class="p-3 text-center bg-primary">
                  <img class="img-avatar img-avatar48 img-avatar-thumb" :src="pic" alt="">
                </div>
                <div class="p-2">
                  <h5 class="dropdown-header text-uppercase ps-2 text-dark">User Options</h5>

                  <a v-on:click="logout()" class="dropdown-item py-1 d-flex align-items-center justify-content-between" href="#">
                    <span>Log Out</span>
                    <i class="mdi mdi-logout ms-1"></i>
                  </a>
                </div>
              </div>
            </li>


          </ul>
          <button class="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" data-toggle="offcanvas">
            <span class="mdi mdi-menu"></span>
          </button>
        </div>
      </nav>
<!-- partial -->
      <div class="container-fluid page-body-wrapper">
        <!-- partial:../../partials/_sidebar.html -->
        <nav class="sidebar sidebar-offcanvas" id="sidebar">
          <ul class="nav">
            <li class="nav-item nav-category">Main</li>
            <li class="nav-item " :class="{ 'active': $route.path == '/home' }">
              <a class="nav-link" href="#" v-on:click="routerToOtherPage('home')">
                <span class="icon-bg"><i class="mdi mdi-home-account menu-icon"></i></span>
                <span class="menu-title">Dashboard</span>
              </a>
            </li>
             <li class="nav-item " :class="{ 'active': $route.path == '/clients/search' }">
              <a class="nav-link" href="#" v-on:click="routerToOtherPage('search')">
                <span class="icon-bg"><i class="mdi mdi-magnify menu-icon"></i></span>
                <span class="menu-title">Search</span>
              </a>
            </li>
            <li class="nav-item " :class="{ 'active': $route.path == '/graph' }">
              <a class="nav-link" href="#" v-on:click="routerToOtherPage('graph')">
                <span class="icon-bg"><i class="mdi mdi-chart-bar menu-icon"></i></span>
                <span class="menu-title">Graphs</span>
              </a>
            </li>
            <li class="nav-item " :class="{ 'active': $route.path == '/airtime-purchase/clients' }">
              <a class="nav-link" href="#" v-on:click="routerToOtherPage('blacklist')">
                <span class="icon-bg"><i class="mdi mdi-account-group menu-icon"></i></span>
                <span class="menu-title">Clients</span>
              </a>
            </li>
            <li class="nav-item " :class="{ 'active': $route.path == '/rates' }">
              <a class="nav-link" href="#" v-on:click="routerToOtherPage('rates')">
                <span class="icon-bg"><i class="mdi mdi-cogs menu-icon"></i></span>
                <span class="menu-title">Settings</span>
              </a>
            </li>
            <li class="nav-item " :class="{ 'active': $route.path == '/numbers' }">
              <a class="nav-link" href="#" v-on:click="routerToOtherPage('numbers')">
                <span class="icon-bg"><i class="mdi mdi-phone menu-icon"></i></span>
                <span class="menu-title">Numbers</span>
              </a>
            </li>
            <li class="nav-item " :class="{ 'active': $route.path == '/wallets' }">
              <a class="nav-link" href="#" v-on:click="routerToOtherPage('wallets')">
                <span class="icon-bg"><i class="mdi mdi-wallet menu-icon"></i></span>
                <span class="menu-title">Wallets</span>
              </a>
            </li>
            <li class="nav-item " :class="{ 'active': $route.path == '/messages' }">
              <a class="nav-link" href="#" v-on:click="routerToOtherPage('messages')">
                <span class="icon-bg"><i class="mdi mdi-email menu-icon"></i></span>
                <span class="menu-title">Messages</span>
              </a>
            </li>
             <li class="nav-item " :class="{ 'active': $route.path == '/safaricom' }">
              <a class="nav-link" href="#" v-on:click="routerToOtherPage('safaricom')">
                <span class="icon-bg"><i class="mdi mdi-cash-multiple menu-icon"></i></span>
                <span class="menu-title">Safaricom</span>
              </a>
            </li>
             <li class="nav-item " :class="{ 'active': $route.path == '/airtel' }">
              <a class="nav-link" href="#" v-on:click="routerToOtherPage('airtel')">
                <span class="icon-bg"><i class="mdi mdi-cash-100 menu-icon"></i></span>
                <span class="menu-title">Other Telco</span>
              </a>
              </li>
              <!-- <li class="nav-item " :class="{ 'active': $route.path == '/telkom' }">
              <a class="nav-link" href="#" v-on:click="routerToOtherPage('telkom')">
                <span class="icon-bg"><i class="mdi mdi-cash-100 menu-icon"></i></span>
                <span class="menu-title">Telkom</span>
              </a>
            </li> -->
            <li class="nav-item " :class="{ 'active': $route.path == '/mpesa/credits' }">
              <a class="nav-link" href="#" v-on:click="routerToOtherPage('mpesa-credits')">
                <span class="icon-bg"><i class="mdi mdi-cash-100 menu-icon"></i></span>
                <span class="menu-title">Credits-Bonga</span>
              </a>
            </li>
             <li class="nav-item " :class="{ 'active': $route.path == '/bonus' }">
              <a class="nav-link" href="#" v-on:click="routerToOtherPage('bonus')">
                <span class="icon-bg"><i class="mdi mdi-cash-100 menu-icon"></i></span>
                <span class="menu-title">Bonus</span>
              </a>
            </li>
            <li class="nav-item " :class="{ 'active': $route.path == '/mpesa/b2c' }">
              <a class="nav-link" href="#" v-on:click="routerToOtherPage('mpesa-b2c')">
                <span class="icon-bg"><i class="mdi mdi-bug menu-icon"></i></span>
                <span class="menu-title">B2C Reports</span>
              </a>
            </li>
            <li class="nav-item " :class="{ 'active': $route.path == '/users' }">
              <a class="nav-link" href="#" v-on:click="routerToOtherPage('users')">
                <span class="icon-bg"><i class="mdi mdi-account-group menu-icon"></i></span>
                <span class="menu-title">Users</span>
              </a>
            </li>
            <li class="nav-item " :class="{ 'active': $route.path == '/profile' }">
              <a class="nav-link" href="#" v-on:click="routerToOtherPage('profile')">
                <span class="icon-bg"><i class="mdi mdi-account menu-icon"></i></span>
                <span class="menu-title">Profile</span>
              </a>
            </li>


            <li class="nav-item sidebar-user-actions">
              <div class="sidebar-user-menu">
                <a v-on:click="logout()" href="#" class="nav-link"><i class="mdi mdi-logout menu-icon"></i>
                  <span class="menu-title">Log Out</span></a>
              </div>
            </li>
          </ul>
        </nav>
        <div class="main-panel p-5 mt-2">

            <router-view></router-view>
            </div>

            </div>

    </div>
</template>
<script>
export default {
    data() {
        return {
            lname:'',
            auth:'',
            fname:'',
            pic:'',
        }
    },
    created(){
        // this.ClearSession();
        this.lname=localStorage.getItem('lname');
        this.auth=localStorage.getItem('auth');
         this.fname=localStorage.getItem('fname');
         this.password_changed=localStorage.getItem('password_changed')
         this.pic=localStorage.getItem('pic')
    },
    watch:{
        '$route' (to, from) {
            this.lname=localStorage.getItem('lname');
        this.auth=localStorage.getItem('auth');
         this.fname=localStorage.getItem('fname');
         this.pic=localStorage.getItem('pic');
        }
    },
    methods: {
      routerToOtherPage(val){
        this.$router.push({name: val});
      },
        ClearSession(){
            $(document).ready(function() {
                if ($.cookie('pop') == null) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('auth');
                    $.cookie('pop', '1');
                }
            });
        },
        logout() {
            localStorage.clear();
            localStorage.removeItem('token');
            localStorage.removeItem('auth');
            this.$router.push({name: 'index'});

        },
    }
}
</script>
